// TextInputControlView.js
import eventBus         from 'EventBus.js';
import listService from 'ListService.js';
import BaseControlView from 'BaseControlView.js';
import constants        from "Constants.js";
import template from 'common-inputs/control_drop_down.ejs';
import util from 'util/Util.js';

//=====================================================================
//
// An instance of this view represents a drop down control.
//
// Casey Justus, February, 16 2016
//
//=====================================================================
class DropDownControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-dropdown';

        // PF-4476 Moved to Factory as this model change is being tracked by undo/redo process.
        //this.model.set('selectFields', [{id: this.model.get('id') + '$v' ,text: 'Value'}, {id:this.model.get('id'), text: 'Caption'}], {silent:false});
        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    }

    get kind() {
        return 'BaseStaticControl';
    }

    // @lem: Uses the default render method. I removed the local override. It only tried to manage 'select' on the
    // layout control. The edit visual on the layout is not a real drop-down, and so has no option children on
    // which to set 'select'

}

export default DropDownControlView;
